import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { DeviceService } from '@core/services/device.service';
import { decrypt } from '@core/utils/EncryptUtil';
import { UtilService } from '@shared/services/util.service';
import { SharedModule } from '@shared/shared.module';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-admin-toolbar',
  standalone: true,
  imports: [
      CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        RouterModule,
        SharedModule
  ],
  templateUrl: './admin-toolbar.component.html',
  styleUrl: './admin-toolbar.component.scss'
})
export class AdminToolbarComponent {
 isLogged = false;
  stdBtn = true;
  idRolUsuario: number = 0;
  nombre: string = "";
  @Output() toggleSidenav = new EventEmitter();
  private destroy$ = new Subject<void>();

  idUsuario!: string;
  isMobile = false;

   constructor(
    private router: Router,
    private utilSvc: UtilService,
    private authSvc: AuthService,
    private deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.deviceService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.isMobile = res;
    });

    this.authSvc.isLogged$.pipe(takeUntil(this.destroy$)).subscribe((logueado) => {
      this.isLogged = logueado;
    });

    this.utilSvc.btnSidenav$.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
      this.stdBtn = resp;
    });

    this.authSvc.isUserName$.pipe(takeUntil(this.destroy$)).subscribe((nombre) => {
      this.nombre = nombre || '';
    });

    this.obtenerRolUsuario();
    this.idUsuario = this.authSvc.getIdUser();
  }

    private obtenerRolUsuario(): void {
      const encryptedUsuario = localStorage.getItem('usuarioGarantia');
      if (encryptedUsuario) {
        try {
          const usuario = decrypt<{ idRolApp: number, nombre: string }>(encryptedUsuario);
          this.idRolUsuario = usuario!.idRolApp || 0; // Asignar el rol si existe
          this.nombre = usuario!.nombre || ""; // Asignar el rol si existe
        } catch (error) {
          console.error('Error al desencriptar el usuario:', error);
        }
      } else {
        console.warn('No se encontró información del usuario en localStorage.');
      }
    }
  

  onToggleSidenav(): void {
    this.toggleSidenav.emit();
  }

  onLogout(): void {
    this.utilSvc.openSidenav({ valueBtn: false, valueSide: false });
    this.authSvc.logout();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
